import { IconButton } from '@/components/ui/button.tsx';
import { CirclePlus } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PatientsTable } from '@patientMenu/patients/PatientsTable.tsx';
import { SearchPatients } from '@patientMenu/features/SearchPatients.tsx';
import { PatientFiltersPopover } from '@patientMenu/features/PatientFiltersPopover.tsx';
import { cn } from '@/lib/utils';

interface PatientsProps {
  className?: string;
  tableClassName?: string;
}

export function Patients({ className, tableClassName }: PatientsProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleAddPatient = () => {
    navigate(`/patients/add`, { state: { backgroundLocation: location } });
  };

  return (
    <section className={cn('flex min-h-0 flex-col gap-3', className)}>
      <header className="surface-panel flex shrink-0 flex-wrap items-center gap-2 px-3.5 py-2.5">
        <div className="min-w-0 flex-1">
          <SearchPatients />
        </div>
        <PatientFiltersPopover />
        <IconButton onClick={handleAddPatient} leftIcon={CirclePlus} size="default" variant="default">
          Add patient
        </IconButton>
      </header>
      <PatientsTable className={tableClassName} />
    </section>
  );
}
